import { motion, useAnimate } from 'motion/react';
import React, { useEffect } from 'react';
import styled from 'styled-components';

import { UiTypography } from '@/components/ui/Typography';

const LineFillWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  gap: 16px;
`;

const ProgressLineContainer = styled.div`
  width: 90%;
  height: 8px;
  background-color: #78788029;
  border-radius: 4px;
  overflow: hidden;
`;

const ProgressLine = styled(motion.div)`
  height: 100%;
  background: linear-gradient(125.61deg, #7f36f3 21.37%, #ed0d80 105.25%);
  border-radius: 4px;
`;

const LoadingText = styled(UiTypography)`
  text-align: center;
`;

export const SingleStepLoading: React.FC<{
  duration?: number;
  onComplete?: () => void;
}> = ({ duration = 3, onComplete }) => {
  const [scope, animate] = useAnimate();

  useEffect(() => {
    const progressTextElement = document.querySelector(
      '.loading-text-progress',
    );
    const startAnimation = async () => {
      await animate(
        scope.current,
        { width: '100%' },
        {
          duration,
          ease: 'linear',
          onUpdate(value) {
            if (progressTextElement) {
              progressTextElement.textContent = `Loading ${Math.round(
                parseFloat(value),
              )}%`;
            }
          },
          onComplete() {
            if (onComplete) onComplete();
          },
        },
      );
    };

    startAnimation();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [animate, duration, onComplete]);

  return (
    <LineFillWrapper>
      <ProgressLineContainer>
        <ProgressLine ref={scope} style={{ width: '0%' }} />
      </ProgressLineContainer>
      <LoadingText className="loading-text-progress" variant="label-large">
        Loading 0%
      </LoadingText>
    </LineFillWrapper>
  );
};
